// src/pages/admin/logs/components/LogTableView.js
import React from 'react';
import { Table, Spinner, Button } from 'react-bootstrap';
import { Eye } from 'lucide-react';

const LogTableView = ({ activeTab, loading, logs, pagination, getLevelBadge, setSelectedLog }) => {
    return (
        <div className="table-responsive">
            <Table hover align="middle" className="m-0 text-nowrap table-dark table-borderless activity-logs-table">
                <thead className="activity-logs-thead">
                    <tr className="activity-logs-thead-tr">
                        <th className="px-4 py-3 text-uppercase">#</th>
                        <th className="py-3 text-uppercase">{activeTab === 'system' ? 'Source Component' : 'User / Actor'}</th>
                        <th className="py-3 text-uppercase">{activeTab === 'system' ? 'Log Level' : 'Role / Action'}</th>
                        <th className="py-3 text-uppercase">{activeTab === 'system' ? 'Event Message' : 'Action Type'}</th>
                        <th className="py-3 text-uppercase">IP Address</th>
                        <th className="py-3 text-uppercase">Date & Time</th>
                        <th className="px-4 py-3 text-center text-uppercase">Action</th>
                    </tr>
                </thead>
                <tbody style={{ fontSize: '0.9rem' }}>
                    {loading ? (
                        <tr>
                            <td colSpan="7" className="text-center p-5 activity-logs-text-secondary" style={{ backgroundColor: '#151521' }}>
                                <Spinner animation="border" className="me-2" size="sm" /> Loading audit logs from bma_logs_db...
                            </td>
                        </tr>
                    ) : logs.length > 0 ? (
                        logs.map((log, idx) => (
                            <tr key={log.id || idx} className="activity-logs-tbody-tr">
                                <td className="px-4 activity-logs-text-secondary">
                                    {(pagination.current_page - 1) * 12 + idx + 1}
                                </td>
                                <td className="fw-semibold text-white">
                                    {activeTab === 'system' ? (log.source_component || 'SYSTEM') : (log.user_name || log.user_id || 'Unauthenticated')}
                                </td>
                                <td>{getLevelBadge(log)}</td>
                                <td className="activity-logs-text-secondary text-truncate" style={{ maxWidth: '300px' }}>
                                    {activeTab === 'system' ? log.message : (log.description || log.details || log.action_type)}
                                </td>
                                <td className="activity-logs-text-secondary font-monospace small">{log.ip_address || '::1'}</td>
                                <td className="activity-logs-text-secondary small">{new Date(log.created_at || Date.now()).toLocaleString('en-IN')}</td>
                                <td className="px-4 text-center">
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        className="d-inline-flex align-items-center gap-1 rounded-2 px-3"
                                        onClick={() => setSelectedLog(log)}
                                        title="View Log Details"
                                    >
                                        <Eye size={14} /> View
                                    </Button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="7" className="text-center p-5 activity-logs-text-secondary">
                                No logs found matching your criteria.
                            </td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    );
};

export default LogTableView;
